/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：936
 */

module.exports = {
  toastWrapper: "Toast_toastWrapper__1ZDgw",
  toast: "Toast_toast__2P2Z6",
  icon: "Toast_icon__l9Zi2",
  textWrapper: "Toast_textWrapper__2WjbI",
  text: "Toast_text__zk2lK"
}
